/* Linsoul event pages. Fork of the prototype engine (event-detail.js): config + strings from the "Event: intro" section
   (#ed-config), the rest from data attributes. No registration or live inventory is implied. Works without GSAP. */
(() => {
  'use strict';
  if (window.__lsEventPage) return;
  window.__lsEventPage = true;
  const dataNode = document.getElementById('ed-config');
  if (!dataNode) return;
  let cfg;
  try { cfg = JSON.parse(dataNode.textContent); } catch (_) { return; }
  const e = cfg.event, T = cfg.t || {};
  const t = (key, vars) => String(T[key] ?? '').replace(/\{(\w+)\}/g, (m, k) => vars && k in vars ? vars[k] : m);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const $ = selector => document.querySelector(selector);
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const savedKey = 'linsoul.events.saved.v1';
  const checklistKey = 'linsoul.events.checklist.v1.' + e.id;
  const session = new Map();
  function read(key, fallback) {
    try { const value = localStorage.getItem(key); return value ? JSON.parse(value) : fallback; }
    catch (_) { return session.has(key) ? session.get(key) : fallback; }
  }
  function write(key, value) {
    session.set(key, value);
    try { localStorage.setItem(key, JSON.stringify(value)); return true; }
    catch (_) { return false; }
  }
  function dayAt(zone, now = new Date()) {
    try {
      const parts = new Intl.DateTimeFormat('en-CA', {timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(now);
      const get = type => parts.find(x => x.type === type).value;
      return get('year') + '-' + get('month') + '-' + get('day');
    } catch (_) { return now.toISOString().slice(0, 10); }
  }
  function phaseAt(record, now = new Date()) {
    if (['cancelled', 'postponed'].includes(record.publicationStatus)) return record.publicationStatus;
    const day = dayAt(record.timeZone, now);
    return day > record.end ? 'past' : day < record.start ? 'upcoming' : 'today';
  }
  let phase = phaseAt(e);
  const active = () => ['upcoming', 'today'].includes(phase);
  const svg = d => `<svg class="ed-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">${d}</svg>`;
  const externalIcon = (window.LsIcons && window.LsIcons.svg('external', 'ed-icon')) || svg('<path d="M14 4h6v6m0-6-9 9M10 4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-5"/>');
  const arrowIcon = (window.LsIcons && window.LsIcons.svg('arrow', 'ed-icon')) || svg('<path d="M5 12h14m-6-6 6 6-6 6"/>');
  let noticeTimer;
  function notify(message) {
    const n = $('#ed-notice'); if (!n) return;
    clearTimeout(noticeTimer);
    n.textContent = message; n.classList.add('is-visible');
    noticeTimer = setTimeout(() => { n.classList.remove('is-visible'); n.textContent = ''; }, 4200);
  }
  function setPrimary(url, label, external) {
    $$('.ed-primary').forEach(a => {
      a.href = url; a.replaceChildren(document.createTextNode(label + ' '));
      a.insertAdjacentHTML('beforeend', external ? externalIcon : arrowIcon);
      if (external) { a.target = '_blank'; a.rel = 'noopener noreferrer'; }
      else { a.removeAttribute('target'); a.removeAttribute('rel'); }
      if (a.hasAttribute('data-ed-primary-copy')) a.hidden = false;
    });
  }
  const hub = cfg.hub || '/pages/events';
  function refreshPhase() {
    phase = phaseAt(e);
    $$('.ed-page').forEach(n => { n.dataset.phase = phase; });
    const label = {upcoming: t('status_upcoming'), today: t('status_today'), past: t(e.recap ? 'status_report' : 'status_past'), cancelled: t('status_cancelled'), postponed: t('status_postponed')}[phase];
    $$('[data-status-label]').forEach(n => { n.textContent = label; });
    $$('[data-for-active]').forEach(n => { n.hidden = !active(); });
    const admission = $('[data-admission]');
    if (admission) admission.textContent = active() ? cfg.access : t(phase === 'past' ? 'admission_past' : 'admission_changed');
    const note = $('[data-action-note]');
    const gallery = cfg.hasGallery && $('#ed-gallery');
    if (phase === 'past') {
      if (e.recap && gallery) setPrimary('#ed-gallery', t('primary_gallery'), false);
      else setPrimary(hub + '#ev-calendar', t('primary_next'), false);
      if (note) note.textContent = t(e.recap && gallery ? 'note_past_report' : 'note_past');
    } else if (['cancelled', 'postponed'].includes(phase)) {
      setPrimary(e.organizer || e.source || hub, t('primary_update'), !!(e.organizer || e.source));
      if (note) note.textContent = t('note_changed', {status: label});
    } else {
      if (cfg.primary.url) setPrimary(cfg.primary.url, cfg.primary.label, true);
      else setPrimary(hub + '#ev-calendar', t('primary_next'), false);
      if (note) note.textContent = t('note_active');
    }
    const retired = $('[data-retired-message]');
    if (retired) retired.hidden = phase === cfg.initialPhase || active();
    $$('.ed-subnav-links a').forEach(a => {
      const target = $(a.getAttribute('href'));
      a.hidden = !target || target.hidden;
    });
    $$('[data-related-id]').forEach(el => {
      el.hidden = !['upcoming', 'today'].includes(phaseAt({start: el.dataset.start, end: el.dataset.end, timeZone: el.dataset.zone}));
    });
    const list = $('.ed-next-grid');
    if (list && list.dataset.empty && !list.querySelector('article:not([hidden])') && !list.querySelector('.ed-empty-next')) {
      const p = document.createElement('p'); p.className = 'ed-empty-next'; p.textContent = list.dataset.empty; list.append(p);
    }
  }
  refreshPhase();
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshPhase(); });
  setInterval(refreshPhase, 60000);

  // Back links accept only known hub filters, never an arbitrary return URL.
  try {
    const raw = new URLSearchParams(location.search).get('from');
    if (raw) {
      const input = new URLSearchParams(raw), safe = new URLSearchParams();
      ['scope', 'q', 'region', 'type', 'year', 'view'].forEach(key => { const v = input.get(key); if (v) safe.set(key, v.slice(0, 180)); });
      if ([...safe].length) $$('[data-back-events]').forEach(a => { a.href = hub + '?' + safe.toString() + '#ev-calendar'; });
    }
  } catch (_) { /* The default link remains valid. */ }

  // City pin on the shared world map (same projection as the events hub).
  $$('.ed-map-pin[data-lat]').forEach(pin => {
    const lat = parseFloat(pin.dataset.lat), lon = parseFloat(pin.dataset.lon);
    if (isNaN(lat) || isNaN(lon)) return;
    const A1 = 1.340264, A2 = -0.081106, A3 = 0.000893, A4 = 0.003796, M = Math.sqrt(3) / 2;
    const p = Math.asin(M * Math.sin(lat * Math.PI / 180)), p2 = p * p, p6 = p2 * p2 * p2;
    const x = (lon * Math.PI / 180) * Math.cos(p) / (M * (A1 + 3 * A2 * p2 + p6 * (7 * A3 + 9 * A4 * p2)));
    const y = p * (A1 + A2 * p2 + p6 * (A3 + A4 * p2));
    pin.style.left = (18.48467 * x + 49.99901).toFixed(3) + '%';
    pin.style.top = (-42.62431 * y + 56.21881).toFixed(3) + '%';
    pin.removeAttribute('data-unplaced');
  });

  let saved = new Set((read(savedKey, []) || []).filter(x => typeof x === 'string'));
  function renderSaved() {
    $$('[data-ed-save]').forEach(b => { const on = saved.has(e.id); b.setAttribute('aria-pressed', String(on)); const s = b.querySelector('span'); if (s) s.textContent = t(on ? 'saved_label' : 'save_label'); });
  }
  renderSaved();
  $$('[data-ed-save]').forEach(b => b.addEventListener('click', () => {
    // Merge current storage to avoid dropping changes made in another tab.
    const latest = read(savedKey, Array.from(saved));
    if (Array.isArray(latest)) saved = new Set(latest);
    saved.has(e.id) ? saved.delete(e.id) : saved.add(e.id);
    const ok = write(savedKey, Array.from(saved)); renderSaved();
    notify(saved.has(e.id) ? t(ok ? 'toast_saved' : 'toast_saved_session') : t('toast_removed'));
  }));
  window.addEventListener('storage', ev => { if (ev.key !== savedKey) return; const raw = read(savedKey, []); saved = new Set(Array.isArray(raw) ? raw : []); renderSaved(); });

  const status = $('#ed-checklist-status');
  const checks = read(checklistKey, {});
  $$('[data-check]').forEach(input => {
    input.checked = Boolean(checks && checks[input.dataset.check]);
    input.addEventListener('change', () => {
      const state = {}; $$('[data-check]').forEach(x => { state[x.dataset.check] = x.checked; });
      const ok = write(checklistKey, state);
      if (status) status.textContent = ok ? status.dataset.saved : status.dataset.session;
    });
  });
  if (status && Object.values(checks || {}).some(Boolean) && status.dataset.restored) status.textContent = status.dataset.restored;

  $$('[data-product-category]').forEach(button => button.addEventListener('click', () => {
    const kind = button.dataset.productCategory; let count = 0;
    $$('[data-product-category]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    $$('.ed-product').forEach(card => { card.hidden = kind !== 'All' && card.dataset.productKind !== kind; if (!card.hidden) count++; });
    const live = $('#ed-product-status');
    if (live) live.textContent = (count === 1 ? live.dataset.countOne : live.dataset.countOther || '').replace('{count}', count);
  }));

  // Shared accessible fallback for browsers without clipboard access.
  const copyDialog = $('#ed-copy-dialog'); let copyOpener = null;
  function safeLink() { const url = new URL(location.href); ['from', 'preview_theme_id'].forEach(k => url.searchParams.delete(k)); url.hash = ''; return url.href; }
  async function copy(text, label, opener) {
    try {
      if (!navigator.clipboard || !window.isSecureContext) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(text); notify(t('toast_copied', {label}));
    } catch (_) {
      if (!copyDialog || !copyDialog.showModal) { window.prompt(label, text); return; }
      copyOpener = opener; $('#ed-copy-title').textContent = t('copy_title', {label: label.toLowerCase()});
      $('#ed-copy-value').value = text;
      copyDialog.showModal(); $('#ed-copy-value').focus(); $('#ed-copy-value').select();
    }
  }
  $$('[data-ed-share]').forEach(b => b.addEventListener('click', () => copy(safeLink(), t('copy_link_label'), b)));
  $$('[data-copy-address]').forEach(b => b.addEventListener('click', () => { if (!e.privateVenue && e.address) copy(e.address, t('copy_address_label'), b); }));
  if (copyDialog) {
    $('[data-copy-close]')?.addEventListener('click', () => copyDialog.close());
    copyDialog.addEventListener('close', () => { if (copyOpener && copyOpener.isConnected) copyOpener.focus(); });
  }
  $$('[data-ed-print]').forEach(b => b.addEventListener('click', () => window.print()));

  // Calendar file: all-day, exclusive next-day end, venue-local dates.
  const dateObj = str => new Date(str + 'T12:00:00Z');
  const icsEscape = s => String(s).replace(/\\/g, '\\\\').replace(/\r?\n/g, '\\n').replace(/;/g, '\\;').replace(/,/g, '\\,');
  function foldLine(s) {
    const enc = new TextEncoder(); let lines = [], line = '', bytes = 0;
    for (const c of s) { const len = enc.encode(c).length; if (bytes + len > 73) { lines.push(line); line = ' '; bytes = 1; } line += c; bytes += len; }
    lines.push(line); return lines.join('\r\n');
  }
  function calendarText() {
    const end = dateObj(e.end); end.setUTCDate(end.getUTCDate() + 1);
    const stamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
    const link = e.organizer || e.source || safeLink();
    const lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Linsoul//Events//EN', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH', 'BEGIN:VEVENT', `UID:${e.id}@${location.hostname}`, `DTSTAMP:${stamp}`, `DTSTART;VALUE=DATE:${e.start.replace(/-/g, '')}`, `DTEND;VALUE=DATE:${end.toISOString().slice(0, 10).replace(/-/g, '')}`, `SUMMARY:${icsEscape(t('ics_summary', {name: e.name}))}`, `LOCATION:${icsEscape(e.address || [e.venue, e.city, e.country].filter(Boolean).join(', '))}`, `DESCRIPTION:${icsEscape(t('ics_description', {zone: e.timeZone, url: link}))}`, `URL:${link}`, 'STATUS:CONFIRMED', 'TRANSP:TRANSPARENT', 'END:VEVENT', 'END:VCALENDAR'];
    return lines.map(foldLine).join('\r\n') + '\r\n';
  }
  $$('[data-ed-calendar]').forEach(b => b.addEventListener('click', () => {
    if (!active()) return;
    const url = URL.createObjectURL(new Blob([calendarText()], {type: 'text/calendar;charset=utf-8'}));
    const a = document.createElement('a'); a.href = url; a.download = e.id + '.ics'; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 3000);
    notify(t('toast_calendar'));
  }));

  const lightbox = $('#ed-lightbox');
  let gallery = [];
  try { gallery = JSON.parse($('[data-ed-gallery]')?.textContent || '[]'); } catch (_) {}
  if (lightbox && gallery.length) {
    document.body.appendChild(lightbox);
    let index = 0, opener = null, oldOverflow = '';
    const image = $('#ed-lightbox-image');
    const captionTpl = lightbox.dataset.caption || '{caption}';
    function showPhoto(i) {
      index = (i + gallery.length) % gallery.length;
      const photo = gallery[index]; image.hidden = false; image.src = photo.src; image.alt = photo.alt || '';
      $('#ed-lightbox-caption').textContent = captionTpl.replace('{n}', index + 1).replace('{total}', gallery.length).replace('{caption}', photo.caption || '');
      $('#ed-lightbox-source').href = photo.full || photo.src;
      if (window.gsap && !reduceMotion.matches) window.gsap.fromTo('#ed-lightbox-caption', {y: 4, autoAlpha: 0}, {y: 0, autoAlpha: 1, duration: .18, overwrite: true, clearProps: 'transform,opacity,visibility'});
    }
    $$('[data-gallery-index]').forEach(b => b.addEventListener('click', () => {
      if (!lightbox.showModal) { window.open(gallery[Number(b.dataset.galleryIndex)].full, '_blank', 'noopener'); return; }
      opener = b; oldOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
      showPhoto(Number(b.dataset.galleryIndex)); lightbox.showModal(); $('[data-lightbox-close]').focus();
    }));
    $('[data-lightbox-close]').addEventListener('click', () => lightbox.close());
    $('[data-gallery-prev]').addEventListener('click', () => showPhoto(index - 1));
    $('[data-gallery-next]').addEventListener('click', () => showPhoto(index + 1));
    lightbox.addEventListener('keydown', ev => { if (ev.key === 'ArrowRight') { ev.preventDefault(); showPhoto(index + 1); } if (ev.key === 'ArrowLeft') { ev.preventDefault(); showPhoto(index - 1); } });
    lightbox.addEventListener('click', ev => { const r = lightbox.getBoundingClientRect(); if (ev.target === lightbox && (ev.clientX < r.left || ev.clientX > r.right || ev.clientY < r.top || ev.clientY > r.bottom)) lightbox.close(); });
    lightbox.addEventListener('close', () => { document.body.style.overflow = oldOverflow; if (opener && opener.isConnected) opener.focus(); });
  }

  const header = document.querySelector('[data-site-header]')?.closest('.shopify-section');
  function headerSize() {
    const h = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--ed-sticky-top', h + 'px');
    $$('.ed-page').forEach(n => n.style.setProperty('--ed-sticky-top', h + 'px'));
  }
  headerSize();
  if ('ResizeObserver' in window && header) new ResizeObserver(headerSize).observe(header);
  window.addEventListener('resize', headerSize, {passive: true});
  const dock = $('[data-ls-ev-dock]');
  const dockRow = dock && dock.querySelector('.ed-subnav-links');
  let raf = false;
  function updateSection() {
    raf = false;
    const line = window.innerHeight * 0.35;
    let current = null;
    $$('.ed-subnav-links a:not([hidden])').forEach(a => { const target = $(a.getAttribute('href')); if (target && target.getBoundingClientRect().top <= line) current = a; });
    if (!current) current = $('.ed-subnav-links a:not([hidden])');
    $$('.ed-subnav-links a').forEach(a => { if (a === current) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
    if (current && dockRow && dockRow.scrollWidth > dockRow.clientWidth) {
      dockRow.scrollTo({left: current.offsetLeft - (dockRow.clientWidth - current.offsetWidth) / 2, behavior: reduceMotion.matches ? 'auto' : 'smooth'});
    }
  }

  if (dock) {
    const heroActions = $('.ed-hero .ed-actions');
    let pastHero = dock.dataset.show === 'always' || !heroActions;
    let keyboardOpen = false;
    const locked = () => {
      const html = document.documentElement;
      return html.style.overflow === 'hidden' || document.body.style.overflow === 'hidden'
        || html.classList.contains('prevent-scroll') || html.classList.contains('ls-scroll-lock')
        || Boolean(document.querySelector('dialog[open]'));
    };
    const renderDock = () => {
      const visible = pastHero && !keyboardOpen && !locked();
      dock.toggleAttribute('data-visible', visible);
      dock.inert = !visible;
      const h = visible ? dock.offsetHeight + 'px' : '0px';
      if (document.body.style.getPropertyValue('--ls-dock-h') !== h) document.body.style.setProperty('--ls-dock-h', h);
    };
    if (heroActions && dock.dataset.show !== 'always') {
      new IntersectionObserver(([entry]) => {
        pastHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        renderDock();
      }).observe(heroActions);
    }
    new MutationObserver(renderDock).observe(document.documentElement, {attributes: true, attributeFilter: ['class', 'style']});
    new MutationObserver(renderDock).observe(document.body, {attributes: true, attributeFilter: ['class', 'style']});
    document.addEventListener('close', () => setTimeout(renderDock), true);
    document.addEventListener('toggle', () => setTimeout(renderDock), true);
    if (window.visualViewport) {
      const onViewport = () => {
        const field = document.activeElement;
        const typing = field && field.matches('input:not([type=radio]):not([type=checkbox]), textarea, select, [contenteditable]');
        keyboardOpen = Boolean(typing) && window.visualViewport.height < window.innerHeight * 0.75;
        renderDock();
      };
      window.visualViewport.addEventListener('resize', onViewport);
      document.addEventListener('focusout', () => setTimeout(onViewport, 50));
    }
    if ('ResizeObserver' in window) new ResizeObserver(renderDock).observe(dock);
    renderDock();
  }
  window.addEventListener('scroll', () => { if (!raf) { raf = true; requestAnimationFrame(updateSection); } }, {passive: true});
  $$('.ed-subnav-links a').forEach(a => a.addEventListener('click', () => {
    const target = $(a.getAttribute('href')); if (target) { target.setAttribute('tabindex', '-1'); setTimeout(() => target.focus({preventScroll: true}), 50); }
  }));
  updateSection();
  $$('[data-enhanced]').forEach(n => { if (!n.hasAttribute('data-for-active') || active()) n.hidden = false; });
  $$('.ed-page').forEach(n => n.classList.add('is-enhanced'));
})();
